module.exports = __webpack_public_path__ + "img/common-commercial.81780eb2.png";